import { HttpClient } from '@angular/common/http';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
var LimitsService = /** @class */ (function () {
    function LimitsService(http) {
        this.http = http;
    }
    LimitsService.prototype.fetchLimits = function () {
        return this.http.get('/account/limits');
    };
    LimitsService.ngInjectableDef = i0.defineInjectable({ factory: function LimitsService_Factory() { return new LimitsService(i0.inject(i1.HttpClient)); }, token: LimitsService, providedIn: "root" });
    return LimitsService;
}());
export { LimitsService };
